import React from 'react'
import Alert from './Alert'
import ContentContainer from './ContentContainer'
import {resetCache} from './Reset'
import * as CacheUtils from '../util/CacheUtils'
import * as DataUtils from '../util/DataUtils'
import * as TypeUtils from '../util/TypeUtils'

export const AGGREGATES = 'aggregates'
export const SCROLL_Y = 'scrollY'
export const SLUGS = 'slugs'

export default class ContentList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
    this.onScroll = this.onScroll.bind(this)
    this.onSearch = this.onSearch.bind(this)
  }
  static getDerivedStateFromProps(nextProps, prevState) {

    return null
  }
  componentDidMount() {
    this.setup(()=>{
      // get scroll position
      const scrollY = CacheUtils.get(SCROLL_Y)
      if (TypeUtils.isNumber(scrollY)) {
        window.scrollTo(0,scrollY)
      } else {
        this.onScroll()
      }
      window.addEventListener('scroll', this.onScroll)
    })
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }
  // FIXME: somehow scroll y position seems not that accurate, sometimes too off on coming back
  onScroll() {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    const scroll = {
       x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
       y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    }
    if (TypeUtils.isNumber(scroll.y)) {
      CacheUtils.set(SCROLL_Y, scroll.y)
    }
  }
  // check either need to reset cache
  reload(cb) {
    this.fetchUpdated(updated=>{
      const lastUpdated = CacheUtils.get(DataUtils.UPDATED)
      if (lastUpdated===undefined||lastUpdated!==updated) {
        resetCache()
        CacheUtils.set(DataUtils.UPDATED,updated)
      }
      if (typeof(cb)==='function') {
        cb()
      }
    })
  }
  fetchUpdated(cb) {
    const dataPath = `/data`
    const indexesPath = `${dataPath}/indexes`
    const fileName = `${DataUtils.UPDATED}.json`
    const filePath = `${indexesPath}/${fileName}`
    DataUtils.fetchText(filePath,text=>{
      if (TypeUtils.isNonEmptyString(text)) {
        const updated = Math.parseInt(text)
        if (TypeUtils.isNumber(updated)) {
          if (typeof(cb)==='function') {
            cb(updated)
          }
        }
      }
    }, ()=>{
      if (typeof(cb)==='function') {
        cb()
      }
    })
  }
  setup(cb) {
    this.reload(()=>{
      const aggregates = CacheUtils.get(AGGREGATES)
      if (TypeUtils.isNonEmptyArray(aggregates)) {
        this.setState({
          aggregates: aggregates,
        },()=>{
          const name = this.props.name
          const aggregate = aggregates.find(e=>e.name===name)
          if (TypeUtils.isObject(aggregate)) {
            this.setState({aggregate:aggregate},()=>{
              const queue = CacheUtils.get(name)
              const index = queue.index
              const contents = queue.contents
              if (
                TypeUtils.isObject(queue)&&
                TypeUtils.isNumber(index)&&
                TypeUtils.isNonEmptyArray(contents)&&
                true
              ) {
                this.setState({
                  index: index,
                  contents: contents,
                }, ()=>{
                  if (typeof(cb)==='function') {
                    cb()
                  }
                })
              } else {
                this.fetchContents(cb)
              }
            })
          } else {
            this.fetchContents(cb)
          }
        })
      } else {
        this.fetchAggregates(()=>{
          this.fetchContents(cb)
        })
      }
    })
  }
  fetchAggregates(cb) {
    const dataPath = `/data`
    const indexesPath = `${dataPath}/indexes`
    const fileName = `_.json`
    const filePath = `${indexesPath}/${fileName}`
    DataUtils.fetchArray(filePath, data=>{
      const aggregates = data
      if (Array.isArray(aggregates)&&aggregates.length>0) {
        CacheUtils.set(AGGREGATES,aggregates)
        this.setState({
          aggregates: aggregates,
        },()=>{
          if (typeof(cb)==='function') {
            cb()
          }
        })
      } else {
        this.setState({message:{
          type: 'warning',
          value: 'List is empty!',
        }})
      }
    }, this.cbe)
  }
  fetchContents(cb) {
    const dataPath = `/data`
    const indexesPath = `${dataPath}/indexes`
    const aggregates = this.state.aggregates
    const name = this.props.name
    const aggregate = aggregates.find(e=>e.name===name)
    const index = this.state.index||0
    if (typeof(aggregate)==='object'&&aggregate!==null) {
      const count = aggregate.count
      //const size = aggregate.size
      const pageCount = aggregate.pageCount
      if (count>0&&index<=pageCount) {
        const fileName = `${name}_${index}.json`
        const filePath = `${indexesPath}/${fileName}`
        this.setState({
          aggregate: aggregate,
        },()=>{
          DataUtils.fetchArray(filePath, data=>{
            const contents = data
            if (Array.isArray(contents)&&contents.length>0) {
              this.setState({
                contents: (this.state.contents||[]).concat(contents),
                index: index+1,
              }, ()=>{
                if (typeof(this.props.name)==='string'&&this.props.name.length>0) {
                  CacheUtils.set(this.props.name,{
                    contents: this.state.contents,
                    index: this.state.index,
                  })
                }
                if (typeof(cb)==='function') {
                  cb()
                }
              })
            } else {
              if (typeof(cb)==='function') {
                cb()
              }
            }
          }, this.cbe)
        })
      }
    }
  }
  hasMore() {
    const aggregate = this.state.aggregate
    if (TypeUtils.isObject(aggregate)) {
      const count = aggregate.count
      //const size = aggregate.size
      const pageCount = aggregate.pageCount
      const index = this.state.index
      if (TypeUtils.isNumber(index)&&count>0&&index<pageCount) {
        return true
      }
    }
    return false
  }
  more(cb) {
    if (this.hasMore()) {
      this.fetchContents(cb)
    }
  }
  onSearch(event) {
    const value = TypeUtils.isString(event)?event:event.target.value
    this.setState({q:value},()=>{
      if (this.hasMore()) {
        this.more(()=>{
          this.onSearch(value)
        })
      }
    })
  }
  cbe=(e)=>{
    if (TypeUtils.isObject(e)) {
      this.setState({message:{
        type: 'danger',
        value: `Something is not right! ${e.message}`,
      }})
    }
  }
  render() {
    return (
      <React.Fragment>
        {
          typeof(this.state.message)==='object'&&
          this.state.message!==null&&
          <Alert {...this.state.message} />
        }
        <div className="row mb-3">
          <div className="col">
            <p>
              Viewing {(this.state.contents||[]).length}
            </p>
          </div>
          <div className="col">
            <div className="float-right">
              <input
                type="search"
                className="form-control mr-sm-2"
                placeholder="Search..."
                onChange={this.onSearch}
              />
            </div>
          </div>
        </div>
        <div className={this.props.className}>
          {
            (this.state.contents||[]).filter(content=>{
              const q = this.state.q
              if (TypeUtils.isNonEmptyString(q)) {
                if (TypeUtils.isObject(content)) {
                  const keys = Object.keys(content)
                  if (TypeUtils.isNonEmptyArray(keys)) {
                    for (let i in keys) {
                      const key = keys[i]
                      if (TypeUtils.isNonEmptyString(key)) {
                        const value = content[key]
                        if (TypeUtils.isNonEmptyString(value)) {
                          return value.toLowerCase().includes(q.toLowerCase())
                        }
                      }
                    }
                  }
                }
                return false
              }
              return true
            }).map((content,index)=>(
              <ContentContainer
                key={index}
                {...content}
                viewMode="teaser"
                /*onClick={()=>{
                  console.log(content);
                }}*/
              />
            ))
          }
        </div>
        {
          this.hasMore()&&
          <div className="mb-3">
            <button className="btn btn-outline-primary"
              onClick={()=>{this.more()}}>More</button>
          </div>
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentList.js